import React from 'react';
import classNames from 'classnames';

import { Node } from '@uncinc/react-drupal-core';

const ParagraphTestimonial = ({ entity, className }) => {
  const classes = classNames('Paragraph ParagraphTestimonial', className);

  const testimonialEntity = entity.getIn(['field_testimonial', 0, 'entity'], '');

  return (
    <div className={classes}>
      <Node entity={testimonialEntity} viewMode="large" />
    </div>
  );
};

export default ParagraphTestimonial;
